<div class="content-rooms">
  <div class="room-list-cont" *ngIf="isGroupedView; else hotelMultipleRooms">
    <ng-container *ngFor="let room of hotelDetail?.Result?.RoomsByCode; first as isFirst;let roomRate = index;">
      <div class="item-room">
        <div class="content-gallery" [class.is-first]="isFirst" *ngIf="!!room?.Images?.length">
          <app-carousel [styleDots]="styleDots" [autoMoveItems]="false">
            <div content class="img-cont" *ngFor="let image of room?.Images | slice:0:5; index as id;" [id]="id">
              <app-image
                [type]="typeImageHotel"
                [src]="image.Url"
                [borderRadius]="8"
                [dimension]="'443x'">
              </app-image>
            </div>
          </app-carousel>
        </div>
        <p class="title" [class.not-gallery]="!room?.Images?.length">{{ room.Description| titlecase }}</p>
        <ng-container *ngIf="room?.Beds?.length">
          <div class="bed" *ngFor="let bed of room?.Beds">
            <app-ds-icon
              [icon]="icons.Bed"
              [size]="16"
              [color]="iconFillColor.Secondary">
            </app-ds-icon>
            <app-ds-typography
              [size]="fontSize.XXXS"
              [fontFamily]="fontFamily.Regular"
              [color]="fontColor.Secondary"
              [text]="bed.Quantity + ' ' + bed.Description">
            </app-ds-typography>
          </div>
        </ng-container>
        <ng-container *ngIf="room?.Amenities?.length">
          <app-hotel-room-amenities
            [amenities]=room.Amenities
            [isMobile]="true">
          </app-hotel-room-amenities>
        </ng-container>
        <ng-container *ngFor="let roomByRate of room.RoomsByRate; trackBy: trackByIdx;let i = index;">
          <app-hotel-room-price
            [roomRate]="roomByRate?.RoomRateById"
            [numberRooms]="numberRooms(roomByRate?.RoomRateById)"
            [room]="roomByRate"
            [nights]="nights"
            [isMobile]="true"
            [isPackageDetail]="isPackageDetail$ | async"
            [hasRappiCard]="hasRappiCard"
            [isPrime]="isPrime"
            [classTag]="classTag"
            [isLoggedIn]="isLoggedIn"
            [provider]="hotelDetail?.Result?.HotelProvider"
            [isByhours]="isByhours"
            [hourType]="roomByRate?.RoomRateById?.PackHours"
            (selectRoom)="selectRoom($event,roomByRate?.RoomCode)">
          </app-hotel-room-price>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <ng-template #hotelMultipleRooms>
    <div class="room-multiple-list">
      <div class="item-room" *ngFor="let roomRate of hotelDetail?.Result?.RoomRates; let roomRateNumber = i;">
        <ng-container *ngFor="let roomId of roomRate.RoomIds;let i = index;let isLast = last;">
          <ng-container *ngIf="roomByRoomId(roomId) as room">
            <div class="item-bed" [class.whitout-image]="!hasImage">
              <div class="image" *ngIf="hasImage">
                <app-image [type]="typeImageHotel" [src]="roomImage(room?.Images)" [borderRadius]="8" (errorImage)="errorImage($event)"
                  [dimension]="'120x'">
                </app-image>
              </div>
              <div class="info">
                <p class="guest">{{'SEARCH_MODULE.ROOMS.ROOM'|transloco}} {{i+1}}: <b>{{roomHeaderLabel(room)}}</b></p>
                <p class="title-room">{{room?.Description| titlecase}}</p>
              </div>
            </div>
            <ng-container *ngIf="room?.Beds?.length">
              <div class="description-bed" *ngFor="let bed of room?.Beds">
                <app-ds-icon
                  [icon]="icons.Bed"
                  [size]="16"
                  [color]="iconFillColor.Secondary">
                </app-ds-icon>
                <app-ds-typography
                  [size]="fontSize.XXXS"
                  [fontFamily]="fontFamily.Regular"
                  [color]="fontColor.Secondary"
                  [text]="bed.Quantity + ' ' + bed.Description">
                </app-ds-typography>
              </div>
            </ng-container>
            <div class="line" [class.isLast]="isLast"></div>
            <div class="container-icon" *ngIf="!isLast">
              <app-ds-icon
                [icon]="icons.Add"
                [size]="20"
                [color]="iconFillColor.Secondary">
              </app-ds-icon>
            </div>
          </ng-container>
        </ng-container>
        <app-hotel-room-price
          [roomRate]="roomRate"
          [numberRooms]="numberRooms(roomRate)"
          [room]="roomByRoomId(roomRate.RoomIds[0])"
          [nights]="nights"
          [isPackageDetail]="isPackageDetail$ | async"
          [hasRappiCard]="hasRappiCard"
          [isPrime]="isPrime"
          [classTag]="classTag"
          [isLoggedIn]="isLoggedIn"
          [provider]="hotelDetail?.Result?.HotelProvider"
          [isLoading]="loadingRoom"
          (selectRoom)="selectRoom($event,roomByRoomId(roomRate.RoomIds[0])?.RoomCode)">
        </app-hotel-room-price>
      </div>
    </div>
  </ng-template>
</div>